import React, { Component } from 'react';
import {Route, Switch, withRouter} from "react-router-dom";
import PrivateSummary from "./PrivateSummary";
import {Nav, NavItem} from "react-bootstrap";
import TransactionOverview from "../../transactions/TransactionOverview";
import PredefinedTextOverview from "../../predefined-text/PredefinedTextOverview";
import ValuationOverview from "../../valuations/ValuationOverview";
import {connect} from "react-redux";

class PrivateMain extends Component {
    constructor(props) {
        super(props);
        this.id = props.match.params.id;
    }

    handleSelect(e) {
        this.props.history.push(e);
    }


    render() {
        return (
            <div className="private-main">
                {this.props.customer && <h1 style={{textAlign:"center"}}>{ this.props.customer.name }</h1> }

                <Nav bsStyle="tabs"  activeKey={ window.location.pathname } onSelect={key => this.handleSelect(key)}>
                    <NavItem eventKey={'/customers/'+this.id+'/private'}> Summary </NavItem>
                    <NavItem eventKey={'/customers/'+this.id+'/private/predefined-texts'}> Predefined Texts </NavItem>
                    <NavItem eventKey={'/customers/'+this.id+'/private/transactions'}> Transactions </NavItem>
                    <NavItem eventKey={'/customers/'+this.id+'/private/valuations'}> Valuations </NavItem>
                </Nav>
                <Switch>
                    <Route exact path='/customers/:id/private' component={PrivateSummary}/>
                    <Route exact path='/customers/:id/private/predefined-texts' component={PredefinedTextOverview}/>
                    <Route exact path='/customers/:id/private/transactions' component={TransactionOverview}/>
                    <Route exact path='/customers/:id/private/valuations' component={ValuationOverview}/>
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { customer: state.currentCustomer };
};

export default withRouter(connect(mapStateToProps)(PrivateMain));


// WEBPACK FOOTER //
// ./src/components/customer/private/PrivateMain.js